import React from "react";
import { Box } from "app/components/common";
import normalize from "app/utils/normalize";
import theme from "app/Theme/Theme";
import { IIconBoxProps } from "./type";
import MessagesIcon from "app/components/Icons/MessagesIcon";

const MessageBox = ({
  width = normalize(40),
  height = normalize(40),
  iconWidth = normalize(24),
  iconHeight = normalize(24),
  backgroundColor = "neutral.white",
  iconColor = theme.colors["brand.500"],
  borderRadius = 4,
}: IIconBoxProps) => {
  return (
    <Box
      alignItems="center"
      justifyContent="center"
      backgroundColor={backgroundColor}
      width={width}
      height={height}
      borderRadius={borderRadius}
    >
      <MessagesIcon color={iconColor} width={iconWidth} height={iconHeight} />
    </Box>
  );
};

export default MessageBox;
